import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

import { makeStyles } from "@material-ui/styles";
import { Button, Card, CardActions, CardContent, Typography } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    root: {
        minWidth: "66vw",
        minHeight: "calc(66vh - 110px)",
        [theme.breakpoints.down("sm")]: {
            minWidth: "100vw",
            minHeight: "calc(100vh - 110px)",
        },
        display: "flex",
        alignItems: "center",
        textAlign: "center",
        flexWrap: "wrap",
        flex: 1,
        "& > *": {
            flexGrow: 1,
            width: "100%",
        },
        border: "none",
        backgroundColor: theme.palette.background.paper,
    },
    title: {
        fontSize: 14,
    },
    errorNumber: {
        textAlign: "center",
        fontSize: "12rem",
        [theme.breakpoints.down("sm")]: {
            fontSize: "6rem",
        },
    },
    pos: {
        marginBottom: 12,
    },
    cardActionsRoot: {
        alignItems: "center",
        justifyContent: "center",
    },
}));

const Page403 = (props) => {
    const classes = useStyles();
    const { t } = useTranslation();
    const history = useHistory();

    return (
        <Card className={classes.root} variant="outlined">
            <CardContent>
                <Typography className={classes.title} color="textSecondary" gutterBottom>
                    {t("errors.title")}
                </Typography>
                <Typography variant="h1" component="h1" className={classes.errorNumber}>
                    403
                </Typography>
                <Typography className={classes.pos} color="textSecondary">
                    {t("errors.403.title")}
                </Typography>
                <Typography variant="body2" component="p">
                    {t("errors.403.description")}
                </Typography>
            </CardContent>
            <CardActions classes={{ root: classes.cardActionsRoot }}>
                <Button size="small" onClick={() => history.go(-1)}>
                    {t("errors.go_back")}
                </Button>
                <Button size="small" onClick={() => history.push("/")}>
                    {t("errors.go_home")}
                </Button>
            </CardActions>
        </Card>
    );
};

export default Page403;
